/**
 * @generated SignedSource<<9183dd747686eca1418a23935ac557de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateNotificationSubscriptions = {
  marketing?: boolean | null;
  marketingContactChannels?: ReadonlyArray<string> | null;
  surveyInviteContactChannels?: ReadonlyArray<string> | null;
  surveyInvites?: boolean | null;
  token?: string | null;
};
export type UnsubscribeCardViaTokenMutation$variables = {
  input: UpdateNotificationSubscriptions;
};
export type UnsubscribeCardViaTokenMutation$data = {
  readonly updateNotificationSubscriptionsViaToken: {
    readonly message: string | null;
    readonly notificationSubscriptions: {
      readonly id: string;
      readonly surveyInvites: boolean | null;
    };
  } | null;
};
export type UnsubscribeCardViaTokenMutation = {
  response: UnsubscribeCardViaTokenMutation$data;
  variables: UnsubscribeCardViaTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateNotificationSubscriptionsResponse",
    "kind": "LinkedField",
    "name": "updateNotificationSubscriptionsViaToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationSubscriptions",
        "kind": "LinkedField",
        "name": "notificationSubscriptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "surveyInvites",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnsubscribeCardViaTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnsubscribeCardViaTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "776adaeffedfb63416cfd378672741eb",
    "id": null,
    "metadata": {},
    "name": "UnsubscribeCardViaTokenMutation",
    "operationKind": "mutation",
    "text": "mutation UnsubscribeCardViaTokenMutation(\n  $input: UpdateNotificationSubscriptions!\n) {\n  updateNotificationSubscriptionsViaToken(input: $input) {\n    message\n    notificationSubscriptions {\n      id\n      surveyInvites\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ce3cbce9f6ad8e5b308cc0c02e2fd5ef";

export default node;
